<template>
  <div>
    <form
      @submit.prevent="submitForm"
      class="ecommerce-form action-buttons-fixed"
      novalidate
    >
      <div class="row" v-if="Object.keys(settings).length">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-toggle-right"></i>
                  <h2 class="card-big-info-title">Postavke jezika</h2>
                  <p class="card-big-info-desc">
                    Definirajte osnovne parametre.
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Defaultni jezik
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success col-lg-4">
                        <treeselect
                          v-model="settings.defaultLanguage"
                          :options="languagesArray"
                          :show-count="true"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Koristi defaultni jezik
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <toggle-button
                          :width="65"
                          :height="35"
                          color="#47a447"
                          v-model="settings.useDefaultLanguage"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Jezici
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success col-lg-4">
                        <treeselect
                          v-model="settings.languages"
                          :multiple="true"
                          :options="languagesArray"
                          :disabled="settings.useDefaultLanguage"
                          :show-count="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div
          class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
        >
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';
import { translations } from '@/mixins';
import api from '@/services/api';
import helpers from '@/services/helpers';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'LanguageSettings',
  mixins: [translations],
  components: { ToggleButton, Treeselect },
  data() {
    return {
      key: 'LanguageSettings',
    };
  },
  methods: {
    submitForm() {
      if (this.checkIfDefaultLanguageIsSelected()) {

      this.checkIfDefaultLanguageIsSelectedInLanguageArray();

      api
        .updateSettings(this.key, this.settings)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
      }
    },
    checkIfDefaultLanguageIsSelected() {
      if (!this.settings.defaultLanguage) {
        this.$toast.error('Molimo odaberite defaultni jezik.');
        return false;
      }
      return true;
    },
    checkIfDefaultLanguageIsSelectedInLanguageArray() {
      if (
        this.settings.languages &&
        !this.settings.languages.includes(this.settings.defaultLanguage)
      ) {
        this.settings.languages.push(this.settings.defaultLanguage);
      }
    },
  },
  computed: {
    settings() {
      return this.$store.getters.getSettings;
    },
    languagesArray() {
      return helpers.languages;
    },
  },
  mounted() {
    this.$store.dispatch('getSettings', this.key);
  },
  destroyed() {
    this.$store.commit('INIT_SETTINGS', {});
  },
};
</script>
